var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 389.69 234.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9fafb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.79,205.19H7.58V234H1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.54,221.12v-16h5.81v29.49L17,218.05v16H11.18V204.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.91,205.19v5.74H49.82V234H44V210.93h-7.1v-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.84,205.12v5.78H65.25v5.81h8.68v5.77H65.25v5.81H76.84v5.76H59.45V205.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.38,205.19h9.4a10.56,10.56,0,0,1,7.55,2.94,8.13,8.13,0,0,1,2.79,6.54v.75a9.38,9.38,0,0,1-1.82,5.49,6.63,6.63,0,0,1-3.46,2.67L100.55,234H93.47l-8.28-12.75V234H79.4Zm13.77,9.66A3.85,3.85,0,0,0,92,212.08a5.4,5.4,0,0,0-3.57-1.15H85.17v8h2.24v0h1.93A4,4,0,0,0,93.15,214.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.45,221.12v-16h5.82v29.49l-17.39-16.56v16h-5.79V204.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.28,205.12v5.78H135.69v5.81h8.69v5.77h-8.69v5.81h11.59v5.76H129.9V205.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.74,205.19v5.74h-7.08V234h-5.81V210.93h-7.1v-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.93,209.27A14.55,14.55,0,1,1,195.6,205,14.12,14.12,0,0,1,205.93,209.27Zm-16.54,4.11a8.52,8.52,0,0,0-2.57,6.21,8.76,8.76,0,0,0,8.78,8.76,8.52,8.52,0,0,0,6.19-2.56,8.4,8.4,0,0,0,2.59-6.2,8.81,8.81,0,0,0-8.78-8.78A8.4,8.4,0,0,0,189.39,213.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.15,205.12v5.78H218.57v5.81h8.69v5.77h-8.69v11.57h-5.79V205.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.23,205.19v12.75l7.38-12.75h6.69l-8.53,14.65L264.68,234h-7.05l-8.4-12.09V234h-5.78V205.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.24,205.19H273V234h-5.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.54,205.19v5.74h-7.08V234h-5.81V210.93h-7.1v-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.83,234.21a14.63,14.63,0,0,1,0-29.25l0,.07a14.91,14.91,0,0,1,10.38,4.27l-4.13,4.13a8.56,8.56,0,0,0-6.21-2.57,8.39,8.39,0,0,0-6.19,2.57,8.56,8.56,0,0,0-2.57,6.21,8.78,8.78,0,0,0,15,6.19L319.2,230A14.55,14.55,0,0,1,308.83,234.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.54,205.19v11.54h9.64V205.19H343V234h-5.78V222.47h-9.64V234h-5.77V205.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364,205.12v5.78H352.38v5.81h8.69v5.77h-8.69v5.81H364v5.76H346.58V205.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.88,221.12v-16h5.81v29.49l-17.38-16.56v16h-5.8V204.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,36.33H38.57V191.87H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.44,36.33a2.27,2.27,0,0,0-.07,3.13L72.66,63a2.28,2.28,0,0,0,1.64.75h0A2.32,2.32,0,0,0,76,63.06,95.53,95.53,0,0,1,119.6,37.83a96,96,0,0,1,91.48,24,2.28,2.28,0,0,0,3.2,0l21.29-21.29a2.29,2.29,0,0,0,0-3.24A130,130,0,0,0,144.15,0C107.67,0,74.74,12.9,51.44,36.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.58,46.92a69.94,69.94,0,0,0-17.21,2.22,86.29,86.29,0,0,0-39.58,23.1,2.29,2.29,0,0,0,0,3.19l18,18.5a2.26,2.26,0,0,0,1.62.69A2.47,2.47,0,0,0,108,94C118.36,83.5,127.92,77,143.48,77c15,0,25.19,6.94,35.93,17.38a2.34,2.34,0,0,0,1.59.64h.08a2.25,2.25,0,0,0,1.62-.75l17.6-19.72a2.26,2.26,0,0,0-.11-3.14A87.57,87.57,0,0,0,160.66,49.1,70.86,70.86,0,0,0,143.58,46.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.23,79.06l-17.1,19.16a8.25,8.25,0,0,1-4.15,2.51,42.76,42.76,0,0,1,4.63,19.75,42.15,42.15,0,0,1-13,31.2,44.18,44.18,0,0,1-62.32,0,44.27,44.27,0,0,1-8-51.57,8.12,8.12,0,0,1-3.72-2.06l-18-18.52a.56.56,0,0,1,0-.08A70.79,70.79,0,0,0,69.9,120.66q0,30.39,21.58,52,21.49,21.32,52,21.41t52-21.41q21.67-21.49,21.67-52A70.44,70.44,0,0,0,204.23,79.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.72,120.43a21.79,21.79,0,1,0,21.79-21.79A21.82,21.82,0,0,0,121.72,120.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "286.89 125.19 286.89 98.64 286.89 37.04 248.44 37.04 248.44 191.87 286.89 191.87 286.89 125.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "389.69 37.04 335.53 37.04 283.46 89.12 256.38 116.19 283.46 143.27 332.06 191.87 386.21 191.87 310.53 116.19 389.69 37.04"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b20adaaaaa09ff6f8bb4ce0607b118e7.svg";
export { ForwardRef as ReactComponent };